export default "https://0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/63d119dbbe57122fe894a2a7ce7c87f7.jpg";